import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContactPage from "../pages/contact/page";
import ShopPage from "../pages/shop/page";
import CartPage from "../pages/cart/page";
import CheckoutPage from "../pages/checkout/page";
import MinePage from "../pages/mine/page";
import CommunityPage from "../pages/community/page";
import WalletPage from "../pages/wallet/page";
import TransferPage from "../pages/transfer/page";
import SettingsPage from "../pages/settings/page";
import ProductDetailPage from "../pages/productDetail/page";
import OrdersPage from "../pages/orders/page";
import OrderDetailPage from "../pages/orderDetail/page";
import InvitePage from "../pages/invite/page";
import FeedbackPage from "../pages/feedback/page";
import LoginPage from "../pages/login/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminProductsPage from "../pages/admin/products/page";
import AdminOrdersPage from "../pages/admin/orders/page";
import AdminMembersPage from "../pages/admin/members/page";
import PlaceholderPage from "../pages/admin/placeholder/page";
import AdminStatsPage from "../pages/admin/stats/page";
import AdminSettingsPage from "../pages/admin/settings/page";
import AdminLogsPage from "../pages/admin/logs/page";
import AdminAnnouncementsPage from "../pages/admin/announcements/page";
import AdminHomeDesignPage from "../pages/admin/homeDesign/page";
import AdminFeedbacksPage from "../pages/admin/feedbacks/page";
import AdminGuard from "../components/feature/AdminGuard";
import ExpresswayPage from "../pages/expressway/page";

const routes: RouteObject[] = [
  // 前台路由
  { path: "/", element: <Home /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/shop", element: <ShopPage /> },
  { path: "/product/:id", element: <ProductDetailPage /> },
  { path: "/cart", element: <CartPage /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/mine", element: <MinePage /> },
  { path: "/orders", element: <OrdersPage /> },
  { path: "/order/:id", element: <OrderDetailPage /> },
  { path: "/community", element: <CommunityPage /> },
  { path: "/wallet", element: <WalletPage /> },
  { path: "/transfer", element: <TransferPage /> },
  { path: "/invite", element: <InvitePage /> },
  { path: "/feedback", element: <FeedbackPage /> },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/expressway", element: <ExpresswayPage /> },
  // 后台路由
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin", element: <AdminGuard><AdminDashboard /></AdminGuard> },
  { path: "/admin/products", element: <AdminGuard><AdminProductsPage /></AdminGuard> },
  { path: "/admin/orders", element: <AdminGuard><AdminOrdersPage /></AdminGuard> },
  { path: "/admin/members", element: <AdminGuard><AdminMembersPage /></AdminGuard> },
  { path: "/admin/managers", element: <AdminGuard><PlaceholderPage title="管理员" icon="ri-admin-line" /></AdminGuard> },
  { path: "/admin/shop", element: <AdminGuard><PlaceholderPage title="店铺管理" icon="ri-store-2-line" /></AdminGuard> },
  { path: "/admin/content", element: <AdminGuard><PlaceholderPage title="内容管理" icon="ri-article-line" /></AdminGuard> },
  { path: "/admin/marketing", element: <AdminGuard><PlaceholderPage title="营销管理" icon="ri-megaphone-line" /></AdminGuard> },
  { path: "/admin/stats", element: <AdminGuard><AdminStatsPage /></AdminGuard> },
  { path: "/admin/client", element: <AdminGuard><PlaceholderPage title="客户端" icon="ri-smartphone-line" /></AdminGuard> },
  { path: "/admin/apps", element: <AdminGuard><PlaceholderPage title="应用中心" icon="ri-apps-2-line" /></AdminGuard> },
  { path: "/admin/settings", element: <AdminGuard><AdminSettingsPage /></AdminGuard> },
  { path: "/admin/logs", element: <AdminGuard><AdminLogsPage /></AdminGuard> },
  { path: "/admin/announcements", element: <AdminGuard><AdminAnnouncementsPage /></AdminGuard> },
  { path: "/admin/home-design", element: <AdminGuard><AdminHomeDesignPage /></AdminGuard> },
  { path: "/admin/feedbacks", element: <AdminGuard><AdminFeedbacksPage /></AdminGuard> },
  { path: "*", element: <NotFound /> },
];

export default routes;
